/* eslint-disable max-lines-per-function */
import { EventBus, Events } from "jiffy-store";
import loadJS from "common/utils/request/loadjs";

import "./recaptcha-modal.scss";

export default () => {
  window.isLoadedRecaptcha = false;
  const recaptchaModal = document.getElementById("recaptcha-modal");
  const $recaptchaModal = $(recaptchaModal);

  EventBus.on(Events.SHOW_RECAPTCHA_MODAL, ({ target }) => {
    recaptchaModal
      .querySelector(".recaptcha-modal__form")
      .setAttribute("action", target.button.dataset.url);
    $recaptchaModal.modal("show");
    if (!window.isLoadedRecaptcha) {
      loadJS("https://www.recaptcha.net/recaptcha/api.js").then(() => {
        window.isLoadedRecaptcha = true;
      });
    }
  });

  window.reCaptchaVerify = function reCaptchaVerify(response) {
    if (response === $(".g-recaptcha-response").val()) {
      $("#form-recaptcha").submit();
    }
  };

  window.closeVoteModal = () => {
    $recaptchaModal.modal("hide");
  };
};
